module.exports = __webpack_public_path__ + "img/dalston_b_b1.059b3836.jpg";